import axios from "axios";

export const axioSerempre = axios.create({
  baseURL: "https://1fzqk3npw4.execute-api.us-east-1.amazonaws.com/",
});
